import { defineEphemeralSlice } from "../runtime/defineEphemeralSlice";
import type { RouteHistory } from "../types";

/** Car itinerary session history (not persisted). */
export const routeHistorySlice = defineEphemeralSlice<RouteHistory[]>( {
    "key":     "routeHistory",
    "default": () => [],
} );
